<template>
  <div id="HomePage" @contextmenu.prevent="onRightClick">
    <!-- 轮播图 -->
    <div id="swiper" class="container-fuild">
      <div class="swiper swiper-container banner-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in swiperList" :key="index">
            <!--            <div class="" style=" position: absolute;color: whitesmoke;"><span style="font-size: 100px">{{ item.picname }}</span></div>-->
            <!--            <div class="swiper-zidingyi-font">提高您的空间价值</div>-->
            <img class="swiper-lazy" :src="item.picurl" alt="轮播图">
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>

        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-next swiper-zidingyi-right"></div>
        <div class="swiper-button-prev swiper-zidingyi-left"></div>
      </div>
    </div>

    <!--    <el-carousel indicator-position="outside" height="800px">-->
    <!--      <el-carousel-item v-for="(item,index) in swiperList" :key="index" >-->
    <!--&lt;!&ndash;        <h3>{{ item }}</h3>&ndash;&gt;-->
    <!--&lt;!&ndash;        <image :src="item.picurl"></image>&ndash;&gt;-->
    <!--        <img  :src="item.picurl"/>-->
    <!--      </el-carousel-item>-->
    <!--    </el-carousel>-->


    <div class="brand container">
      <div class="title-h2">
        <!-- <p>Decorate</p> -->
        <!--        <h2>透明装修 · 好施工看得见</h2>-->
        <h2>透明装修 · 关于楚天</h2>
        <div class="hr-long"></div>
      </div>

      <div class="brand-video onphone-flex">
        <div class="brand-video-left">
          <!--          <video src="@/assets/img/video(1).mp4" controls muted></video>-->
<!--          id="videoPlayer" class="video-js"-->
          <video :src="videoData"  controls muted></video>
        </div>
        <div class="brand-video-right phone-hide2">
          <!--          <a href="javascript:;">-->
          <!--            <h3>爱的见证<br />全新定义家的品质</h3>-->
          <!--            <div class="hr-sort"></div>-->
          <!--            <p>业主故事　>>></p>-->
          <!--          </a>-->
          <div style="border-bottom: 1px #97918c solid;height: 25%">
            <a style="display: flex">
              <div style="margin-top: 20px">
                <i class="iconfont icon-shejishi" style="font-size: 50px"></i>
              </div>
              <div style="text-align: center;">
                <h4 style="margin-top: 20px">个性化设计</h4>
                <p style="background-color: #676262;color: #ccc8c8">10年以上设计经验<br>数万套精品案例作品</p>
              </div>
            </a>
          </div>
          <div style="border-bottom: 1px #97918c solid;height: 25%">
            <a style="display: flex">
              <div style="margin-top: 20px">
                <i class="iconfont icon-shigong" style="font-size: 50px"></i>
              </div>
              <div style="text-align: center;">
                <h4 style="margin-top: 20px">自营施工</h4>
                <p style="background-color: #676262;color: #ccc8c8">20多年施工管理经验<br>按公司统一标准施工</p>
              </div>
            </a>
          </div>
          <div style="border-bottom: 1px #97918c solid;height: 25%">
            <a style="display: flex">
              <div style="margin-top: 20px">
                <i class="iconfont icon-gongying" style="font-size: 50px"></i>
              </div>
              <div style="text-align: center;">
                <h4 style="margin-top: 20px">甄选建材</h4>
                <p style="background-color: #676262;color: #ccc8c8">自建仓储统一配送<br>"5选3验"保障大牌正品</p>
              </div>
            </a>
          </div>
          <div style="border-bottom: 1px #97918c solid;height: 25%">
            <a style="display: flex">
              <div style="margin-top: 20px">
                <i class="iconfont icon-shejishi" style="font-size: 50px"></i>
              </div>
              <div style="text-align: center;">
                <h4 style="margin-top: 20px">售后无忧</h4>
                <p style="background-color: #676262;color: #ccc8c8">6S售后服务承诺<br>定期回访及时维护</p>
              </div>
            </a>
          </div>

          <!--          <div class="new-brand-right" style="border: 1px saddlebrown solid;margin-top:0px">-->
          <!--            <a href="javascript:;">-->
          <!--              <div class="brand-forte-right-item" style="display: flex;">-->
          <!--                <i class="iconfont icon-shejishi" style="width: 30%"></i>-->
          <!--                <div>-->
          <!--                  <h4 style="font-weight: bold">个性化设计</h4>-->
          <!--                  <p>10年以上设计经验<br>数万套精品案例作品</p>-->
          <!--                </div>-->

          <!--              </div>-->
          <!--            </a>-->
          <!--          </div>-->
        </div>
      </div>


    </div>
    <div class="cases index-case bg-black">
      <div class="title-h2 bai wow fadeInUp">
        <h2>设计库<STRONG><EM>3000</EM> +</STRONG> 真实客户案例</h2>
      </div>
      <div class="cases-menu container1300">
        <a class="active" @mouseover="handleMouseEnter('qb')" @click="nav('design',0)">全部</a>
        <a class="" v-for="item in classData" @mouseover="handleMouseEnter(item.tyname)"
           @click="nav('design',item.tyname)">{{ item.tyname }}</a>
        <a class="select" @click="nav('design',0)">更多案例</a>
      </div>
      <div class="cases-body container1300">
        <div class="cases-item" v-for="(item,index) in anliData">
          <a href="javascript:;">
            <img :src="item.mainurl" alt=""/>
          </a>
        </div>
      </div>
    </div>
    <div class="design">
      <div class="title-h2 wow fadeInUp ">
        <!--         <p>designer</p>-->
        <h2 class="">资深设计师 · 1对1专属服务</h2>
        <span>平均从业10年以上，上百套家庭装修经验</span>
      </div>
      <div v-if="!showMax">
        <div class="swiper design-swiper container1300">
          <div class="swiper-wrapper">
            <!--            @click="nav('designer')"-->
            <div class="swiper-slide" v-for="(item,index) in sjslist" :key="index" @click="nav('designer')">
              <div class="design-item">
                <div class="design-item-infos">
                  <div>
                    <h3><i class="iconfont icon-sjs"></i>{{item.lbname}}</h3>
                    <p>
                    </p>
                    <p class="design-infos-posi" style="color: red">
                      {{ item.lbfanhao }} |
                      {{ item.lbgender }}年从业经验
                    </p>
                    <p class="margin-top" style="font-size: 14px">擅长风格：<br>{{ item.scfg }}</p><br>
                    <!--                  <p style="font-size: 14px">公司评语：<br>{{item.gspy}}</p>-->
                  </div>
                  <a href="javascript:;">看<span>TA</span>作品</a>
                </div>

                <a href="javascript:;">
                  <img :src="item.dtturl" alt=""/>
                </a>
              </div>
            </div>
          </div>
          <div class="design-arrow">
            <span class="button-prev"><i class="iconfont icon-left-a"></i></span>
            <a href="javascript:;" @click="nav('designer')">查看更多</a>
            <span class="button-next"><i class="iconfont icon-right-a"></i></span>
          </div>
        </div>
      </div>


      <!--        超大屏显示-->
      <div v-if="showMax" class="max-display">
        <div class="max-div-left"></div>
        <div class="container1200">
          <el-carousel trigger="click" :interval="5000" height="400px" indicator-position="outside" :autoplay="true" arrow="never">
            <el-carousel-item v-for="(item,index) in sjslist" :key="index">
              <div class="design-max" @click="nav('designer')">
                <div class="slider-one">
                  <img :src="item.dtturl" alt=""/>
                </div>

                <div class="slider-two" @click="nav('designer')">
                  <p style="font-size: 34px">{{ item.lbname }}<span style="font-size: 14px;color: #888888">&nbsp;&nbsp;{{ item.lbfanhao }}</span>
                  </p>
                  <br>
                  <div class="slider-font">
                    <p>擅长风格：{{ item.scfg }}</p>
                    <p>公司评语：{{ item.gspy }}</p>
                    <p>服务群体：{{ item.fwqt }}</p>
                  </div>
                </div>
                <div class="slider-three">
                  <el-carousel :interval="4000" type="card">
                    <el-carousel-item v-for="(it,i) in item.zpurls" :key="i">
                      <!--                    <h3 class="medium">{{ item }}</h3>-->

                      <img :src="it.url" class="slider-img" alt="">
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="max-div-right"></div>
      </div>


    </div>
    <div class="news">
      <div class="title-h2 wow fadeInUp">
        <h2 class="">新闻资讯</h2>
        <span class="">发现更多不一样的楚天文化</span>
      </div>
      <!-- <div class="news-menu">
        <span class="select">企业新闻</span>
        <span>视频访谈</span>
        <span>装修资讯</span>
        <span>装修问答</span>

      </div> -->
      <div class="news-body container">
        <div class="news-body-item">
          <div class="news-body-item-flex onphone-flex">
            <div class="news-body-left phone-hide2">
              <a href="javascript:;" v-if="qylist.length>0" @click="newto(qylist[0])">
                <img :src="qylist[0].mainurl" class="img-responsive" alt="">
                <div class="news-item">
                  <div class="news-body-title">
                    <h3>{{ qylist[0].title }}</h3>
                  </div>
                  <!-- <div class="news-body-time">
                    <p>08</p>
                    <p>2024-05</p>
                  </div> -->
                </div>
                <p style="color: #777;font-size: 15px">{{ qylist[0].typed }} </p>
              </a>
            </div>
            <div class="news-body-right">
              <a href="javascript:;" class="news-item" v-for="(item,index) in qylist " v-if="index >0" :key="index"
                 @click="newto(item)">
                <!-- <div class="news-body-time phone-hide2">
                  <p>11</p>
                  <p>2024-06</p>
                </div> -->
                <div class="news-body-img-xgang">
                  <img style="width: 140px" :src="item.mainurl" class="" alt="">
                </div>
                <div class="news-body-title">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.typed }} </p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import {
  WOW
} from 'wowjs';
import {
  veteranselect,
  selectaddr,
  tupiansearch,
  getClassData,
  getDataAnli,
  selectusetbyflag
} from '@/api/index'

export default {
  name: "HomePage",
  metaInfo(){
    return {
      title:this.metaInfo.title,
      meta:[
        {
          name:'keyWords',
          content:this.metaInfo.keywords
        },
        {
          name:'description',
          content:this.metaInfo.description
        }
      ]
    }
  },
  data() {
    return {
      swiperList: [],
      sjslist: [],
      qylist: [],
      classData: [],
      anliData: [],
      videoData: '',
      showImage: true,
      currentImage: 0,
      showMax: true,
      metaInfo:{
        title:'',
        keywords:'',
        description:''
      }
    };
  },
  created() {
    // 判断页面是否在手机端打开
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      // console.log('当前在手机端');
      // window.location.href = '小程序链接'
      this.showMax = false
    } else {
      // console.log('当前在PC端');
      this.showMax = true
    }

  },
  mounted() {
    this.haveTitle('title')
    this.haveTitle('keyword')
    this.haveTitle('description')
    this.getClassData()
    this.searchtd()
    this.searchqy()
    this.bannersearch()
    this.handleMouseEnter('qb')
    new Swiper(".forte-swiper", {
      slidesPerView: "auto"
      // spaceBetween: 30
    });
    var servicesSwiper = new Swiper('.services-swiper', {
      autoplay: {
        delay: 5000
      },
      autoplayDisableOnInteraction: false,
      loop: true,
      // navigation: {
      //   nextEl: ".swiper-button-next2",
      //   prevEl: ".swiper-button-prev2"
      // },
      navigation: {
        nextEl: ".services .swiper-button-next",
        prevEl: ".services .swiper-button-prev",
      },
      on: {
        slideChange: function () {
          // console.log(this.realIndex);
          $(".swiper-bot span").removeClass('active');
          $(".swiper-bot span").eq(this.realIndex).addClass('active');
        },
      },
    });
    $('.swiper-bot').on('click', 'span', function (e) {
      var index = $(".swiper-bot span").index(this);
      console.log(index);
      servicesSwiper.slideToLoop(index, 1000, false); //切换到第一个slide，速度为1秒
    });
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    })
    wow.init();

  },
  methods: {
    onRightClick(){
      // 动态设置meta标签
      const meta = document.createElement('meta');
      console.log(meta)
      meta.setAttribute('name', 'keywords');
      meta.setAttribute('content', '123');
      document.getElementsByTagName('head')[0].appendChild(meta);
      return false;
    },
    haveTitle(val){
      selectusetbyflag(val).then(res=>{
        if (res.code === 200){
          if (val === 'title') this.metaInfo.title = res.msg;
          if (val === 'keyword') this.metaInfo.keywords = res.msg;
          if (val === 'description') this.metaInfo.description = res.msg;
        }
      })
    },
    handleMouseEnter(val) {
      let op = {pageNum: 1, pageSize: 6, fengge: val}
      if (val == 'qb') {
        op = {pageNum: 1, pageSize: 6}
      }
      getDataAnli(op).then(res => {
        if (res.code == 200) {
          this.anliData = res.data.list
        }
      })
    },


    getClassData() {
      getClassData({pageNum: 1, pageSize: 5}).then(res => {
        if (res.code == 200) {
          this.classData = res.data.list
        }
      })
    },


    newto(item) {
      this.$router.push({
        name: 'newsdetail',
        query: {
          syid: item.syid
        }
      })
    },
    nav(item, val) {
      this.$router.push({
        name: item,
        query: {val: val}
      })
    },
    searchtd() {
      veteranselect({
        pageNum: 1,
        pageSize: 100
      }).then(res => {

        this.sjslist = res.data.list

        this.sjslist.forEach((item, index) => {
          var temp = item.zpurls.split(",");
          var zpurls = []
          temp.forEach((item, i) => {
            zpurls.push({uid: i, url: item})
          })
          item.zpurls = zpurls

        })

        setTimeout(() => {
          new Swiper('.design-swiper', {
            slidesPerView: 6,
            autoplay: true,
            spaceBetween: 6,
            loop: true,
            breakpointsBase: 'window',
            breakpoints: {
              740: {
                slidesPerView: 2,
              },
              //当swiper宽度大于等于768
              768: {
                slidesPerView: 4,
              },
              1200: {
                slidesPerView: 5,
              },
              1600: {
                slidesPerView: 6,
              }
            },
            navigation: {
              nextEl: ".design .button-next",
              prevEl: ".design .button-prev",
            },
          });
        }, 100)


      })
    },
    searchqy() {
      selectaddr({
        pageNum: 1,
        pageSize: 5
      }).then(res => {
        this.qylist = res.data.list
      })
    },
    bannersearch() {
      tupiansearch({
        pictype: 'indexbanner'
      }).then(res => {
        this.swiperList = res.data
        setTimeout(() => {
          new Swiper(".banner-swiper", {
            autoplay: {
              delay: 3000
            },
            loop: true, // 循环模式选项

            // 延迟加载
            lazy: {
              loadPrevNext: true
            },
            navigation: {
              nextEl: ".banner-swiper .swiper-zidingyi-right",
              prevEl: ".banner-swiper .swiper-zidingyi-left",
            },
            // observer: true, //修改swiper自己或子元素时，自动初始化swiper
            // observeParents: true //修改swiper的父元素时，自动初始化swiper
          });
        }, 3000)

      })
      // 视频
      tupiansearch({
        pictype: 'homeVideo'
      }).then(res => {
        this.videoData = res.data[0].picurl
        // setTimeout(() => {
        //   new Swiper(".banner-swiper", {
        //     loop: true, // 循环模式选项
        //     // 延迟加载
        //     lazy: {
        //       loadPrevNext: true
        //     },
        //   });
        // }, 100)

      })


    }
  }
};
</script>
<style scoped>
/* 整体盒子 */
#HomePage {
  width: 100%;
}

/* 轮播图 */
#swiper {
  height: 120%;
}

#swiper .banner-swiper {
  width: 100%;
  height: 130%;
}

#swiper .banner-swiper .swiper-slide img {
  width: 100%;
  height: 100%;
}

#swiper .banner-swiper .swiper-slide {
  position: relative;
}

#swiper .banner-swiper .swiper-slide-title {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999999;
  width: 100%;
  height: 100%;
  color: #fff;
  text-align: center;
  line-height: 80px;
}

#swiper .banner-swiper .swiper-slide-title > h1 {
  font-size: 50px;
  margin-top: 12%;
}

#swiper .banner-swiper .swiper-slide-title > p {
  font-size: 20px;
  margin-top: 1%;
  font-weight: 700;
}

/* 大数据管理系统 */
#bigData {
  /* padding: 100px; */
  width: 1300px;
  margin: 20px auto;
  transition: all ease 0.6s;
  box-sizing: border-box;
}

#bigData .title-h2 {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding: 30px 0;
  line-height: 40px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #393939;
  padding: 60px 0 40px;
}

#bigData .title-h2 h2 {
  font-size: 40px;
  padding: 30px 0;
  font-weight: bold !important;
}

.hr-long {
  width: 210px;
  height: 4px;
  background-color: #aaa;
}

.swiper-zidingyi-font {
  position: absolute;
  color: whitesmoke;
  margin-top: 18%;
  margin-left: 35%;
  font-size: 80px;
  font-weight: bold
}

/* 您身边的IT专家 */
#contactUs {
  color: #fff;
  height: 400px;
  background: url("../assets/img/contact_us_bg.jpg") 0 0 no-repeat;
  background-size: 100% 100%;
  transition: all ease 0.6s;
}

#contactUs .contactUs-container {
  padding-top: 50px;
}

#contactUs .contactUs-container button {
  width: 300px;
  height: 50px;
  margin-top: 40px;
}

#contactUs .contactUs-container .contactUs-contactWay span {
  display: inline-block;
  width: 48px;
  height: 48px;
  margin: 30px;
}

#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(1) {
  /* background: url("../assets/img/weixin.png") 0 0 no-repeat; */
  background-size: 100% 100%;
}

#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(2) {
  /* background: url("../assets/img/weibo.png") 0 0 no-repeat; */
  background-size: 100% 100%;
}

#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(3) {
  /* background: url("../assets/img/twitter.png") 0 0 no-repeat; */
  background-size: 100% 100%;
}

/* 客户评价 */
#customer {
  padding: 50px 0;
  box-sizing: border-box;
  background: #efefef;
  transition: all ease 0.6s;
}

#customer .customer-title {
  font-size: 30px;
  color: rgb(102, 102, 102);
  margin: 0 0 30px;
}

#customer .customer-block {
  background: #fff;
  padding: 30px;
}

#customer .customer-logo img {
  width: 94px;
  height: 94px;
  border: 1px solid #ccc;
}

#customer .customer-yh img {
  width: 34px;
  height: 34px;
}

#customer .customer-content1 {
  padding-bottom: 20px;
  border-bottom: 1px solid #0ce9f1;
}

#customer .customer-content2 {
  padding-top: 20px;
}

/* 为什么选择我们 */
#whyChooseUs {
  padding: 100px;
}

#whyChooseUs .whyChooseUs-title {
  margin-bottom: 50px;
}

#whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
  font-size: 25px;
  font-weight: 500;
}

/*  .onphone-flex {
  display: flex;
  justify-content: space-between;
} */

.brand-video-left {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.brand-video-left video {
  width: 100%;
  height: 100%;
}

.brand-video-right {
  width: 200px;
  flex-shrink: 0;
  padding: 0 5%;
  color: #FFFFFF;
  background-color: #676262;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: content-box;
}

.new-brand-right {
  width: 100%;
}

.brand-video-right a {
  color: #fff;
  text-decoration: none;
}

.brand-video-right a h3 {
  margin-bottom: 20px;
  font-size: 32px;
  font-weight: bold;
  margin-top: 0;
}

.hr-sort {
  width: 60px;
  height: 4px;
  background-color: #FFFFFF;
}

.brand-video-right p {
  margin-top: 20px;
  font-size: 14px;
  color: black;
  background-color: white;
  width: 150px;
}

.cases-menu a:hover {
  color: #fff;
  background-color: rgba(211, 47, 47, 1);
  text-decoration: none;
}

/* .brand-forte {
  height: 260px;
  padding: 30px 0;
} */

/*  .brand-forte-left {
  background-color: #D32F2F;
  color: #FFFFFF;
  width: 200px;
  padding: 0 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
} */

#whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
  font-size: 14px;
}

#whyChooseUs .server-block {
  padding: 50px 20px;
  border: 1px solid #ccc;
  border-bottom: 5px solid #ccc;
}

#whyChooseUs .server-block img {
  width: 48px;
  height: 48px;
}

#whyChooseUs .server-block > p {
  font-size: 20px;
  margin: 30px 0;
}

#whyChooseUs .server-block > div {
  color: #ccc;
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  #swiper {
    height: 120%;
    margin: 0px auto 0px auto;
    max-width: 100%;
  }

  #bigData {
    padding: 30px;
  }

  #bigData .bigData-title {
    font-size: 20px;
  }

  #bigData .bigData-device {
    font-size: 20px;
    margin: 10px 0 10px;
  }

  #contactUs {
    height: 200px;
    transition: all ease 0.6s;
  }

  #contactUs .contactUs-container {
    padding-top: 0;
  }

  #contactUs .contactUs-container h1 {
    font-size: 25px;
  }

  #contactUs .contactUs-container h3 {
    font-size: 18px;
  }

  #contactUs .contactUs-container button {
    width: 200px;
    height: 30px;
    margin-top: 20px;
  }

  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 28px;
    height: 28px;
    margin: 10px;
  }

  #customer {
    padding: 30px 0;
    box-sizing: border-box;
    background: #fff;
  }

  #customer .customer-title {
    font-size: 16px;
    font-weight: bold;
  }

  #customer .customer-logo img {
    width: 48px;
    height: 48px;
  }

  #customer .customer-block {
    padding: 30px;
  }

  #customer .customer-block > div {
    padding: 30px 0;
  }

  #whyChooseUs {
    padding: 20px 0;
    transition: all ease 0.6s;
  }

  #whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
    font-size: 20px;
    font-weight: 700;
  }

  #whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
    font-size: 12px;
  }

  #whyChooseUs .server-block {
    padding: 50px 0;
    border: 1px solid #ccc;
    border-bottom: 5px solid #ccc;
  }

  #whyChooseUs .server-block img {
    width: 48px;
    height: 48px;
  }

  #whyChooseUs .server-block > p {
    font-size: 20px;
    margin: 30px 0;
  }

  #whyChooseUs .server-block > div {
    color: #ccc;
  }

  .onphone-flex .phone-hide2 {
    display: none;
  }

  .swiper-slide {
    height: 217px;
  }

  .brand-forte-left > p {
    font-size: 13px;
    color: #777;
  }

  .brand-forte-right-item > p {
    font-size: 14px;
  }

  .design-arrow {
    display: none;
  }

  .swiper-zidingyi-font {
    position: absolute;
    color: whitesmoke;
    margin-top: 20%;
    margin-left: 26%;
    font-size: 26px;
    font-weight: bold
  }


}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  #swiper {
    height: 120%;
  }

  #bigData {
    padding: 60px;
  }

  #bigData .bigData-title {
    font-size: 30px;
  }

  #bigData .bigData-device {
    font-size: 30px;
    margin: 30px 0 15px;
  }

  #contactUs {
    height: 300px;
  }

  #contactUs .contactUs-container {
    padding-top: 50px;
  }

  #contactUs .contactUs-container h1 {
    font-size: 30px;
  }

  #contactUs .contactUs-container h3 {
    font-size: 20px;
  }

  #contactUs .contactUs-container button {
    width: 300px;
    height: 50px;
    margin-top: 30px;
  }

  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 32px;
    height: 32px;
    margin: 15px;
  }

  #customer .customer-title {
    font-size: 24px;
  }

  #whyChooseUs {
    padding: 20px 0;
  }

  .swiper-zidingyi-font {
    position: absolute;
    color: whitesmoke;
    margin-top: 18%;
    margin-left: 35%;
    font-size: 35px;
    font-weight: bold
  }


}

.news-body-title h3 {
  //color: #777;
  overflow: hidden; /* 隐藏溢出 */
  word-break: break-all; /* break-all(允许在单词内换行。) */
  text-overflow: ellipsis; /* 超出部分省略号 */
  display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
  -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
  -webkit-line-clamp: 1; /** 显示的行数 **/
  font-family: "微软雅黑";
}

.news-body-title p {
  color: #777;
  overflow: hidden; /* 隐藏溢出 */
  word-break: break-all; /* break-all(允许在单词内换行。) */
  text-overflow: ellipsis; /* 超出部分省略号 */
  display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
  -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
  -webkit-line-clamp: 2; /** 显示的行数 **/
  line-height: 1.6;
  font-family: "MicrosoftYaHei, Microsoft YaHei";
}


.news-body-right a:hover p {
  color: #D32F2F;
}

.active {
  background-color: whitesmoke;
}

.design-max {
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}
.slider-two p{
  margin-top: 20px;
}
.slider-font{
  line-height: 1.6;
  margin-top: 30px;
  margin-bottom: 30px;
}
.swiper-zidingyi-right{
  padding: 20px;
  background-image: url("../assets/img/right.png");
  background-color: rgba(0, 0, 0,0.1);
  border-radius: 10px;
}
.swiper-zidingyi-right:hover{
  background-color: rgba(0, 0, 0, 0.3);
}
.swiper-zidingyi-left{
  padding: 20px;
  background-image: url("../assets/img/left.png");
  background-color: rgba(0, 0, 0,0.1);
  border-radius: 10px;
}
.swiper-zidingyi-left:hover{
  background-color: rgba(0, 0, 0, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/view/HomePage.vue